
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","viewBox":"0 0 8 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 5.604V4.01c0-.71-.252-1.397-.71-1.94A2.998 2.998 0 004.5 1.048V.5A.502.502 0 004 0a.5.5 0 00-.5.501v.547A2.998 2.998 0 001.71 2.07 3.012 3.012 0 001 4.01v1.594a1.5 1.5 0 00-1 1.413V8.02a.502.502 0 00.5.5h1.57A2.005 2.005 0 004 10a1.997 1.997 0 001.93-1.48H7.5a.5.5 0 00.5-.5V7.017a1.506 1.506 0 00-1-1.413zM2 4.01c0-.532.21-1.042.586-1.418A1.997 1.997 0 016 4.01v1.504H2V4.01zm2 5.012a.998.998 0 01-.86-.501h1.72a1.001 1.001 0 01-.86.501zm3-1.504H1v-.5a.502.502 0 01.5-.502h5a.5.5 0 01.5.501v.501z","fill":"#1B4332"}})])
          )
        }
      }
    